import {
	getComplaintTracking,
	setComplaintPage,
} from 'feature/complaintTracking/complaintTrackingSlice';
import { useDebounce } from 'hooks/debouncer.hook';
import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { buildComplaintFilterParams } from 'utils/utils';
import ComplaintTrackingFooter from './ComplaintTrackingFooter.component';
import ComplaintTrackingTable from './ComplaintTrackingTable';
import { setSortingValues } from 'feature/form/formSlice';

const ViewComplaintTracking = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { page } = useSelector((store: RootState) => store.complaintTracking);
	const { sortingFields, sortingDirections } = useSelector(
		(store: RootState) => store.form,
	);
	const form = useSelector((store: RootState) => store.form);

	const { queryParams: searchParams } = buildComplaintFilterParams(form);
	const searchParamsDeb = useDebounce(searchParams);

	useEffect(() => {
		dispatch(
			setSortingValues({
				name: 'complaintId,complaintNotificationDate',
				value: 'DESC,DESC',
			}),
		);

		return () => {
			dispatch(setComplaintPage(1));
		};
	}, [dispatch]);

	useEffect(() => {
		dispatch(setComplaintPage(1));
		dispatch(getComplaintTracking());
	}, [dispatch, searchParamsDeb, sortingFields, sortingDirections]);

	useEffect(() => {
		dispatch(getComplaintTracking());
	}, [dispatch, page]);

	return (
		<Fragment>
			<ComplaintTrackingTable />
			<ComplaintTrackingFooter />
		</Fragment>
	);
};

export default ViewComplaintTracking;
